<div class="gojs-toolbar" [class]="state.positionClass" [intercomTarget]="'model_overview'">
  <div #overviewRef class="gojs-overview" [class.show]="isOverviewActive"></div>
  <div class="zoom-slider">
    <button
      class="option-button mr-0"
      [class.active]="isOverviewActive"
      (click)="toggleOverview()"
      [matTooltip]="isOverviewActive ? 'Hide Overview' : 'Show Overview'"
      matTooltipPosition="left"
      [intercomTarget]="'01-gojs-overview-toggle'"
    >
      <fa-icon [icon]="['fal', isOverviewActive ? 'chevron-down' : 'chevron-up']"></fa-icon>
    </button>
    <span [class.cursor-not-allowed]="state.isFitToScreenDisabled">
      <button
        class="option-button"
        (click)="fitToScreen()"
        [matTooltip]="state.isFitToScreenDisabled ? '' : 'Fit to Screen'"
        [disabled]="state.isFitToScreenDisabled"
        [intercomTarget]="'01-gojs-overview-fitscreen'"
      >
        <fa-icon [icon]="['fal', 'arrows-h']"></fa-icon>
      </button>
    </span>
    <div class="slider">
      <button class="zoom-button" (click)="zoomOut()" [intercomTarget]="'01-gojs-overview-zoomout'">
        <fa-icon [icon]="['fal', 'search-minus']"></fa-icon>
      </button>
      <div class="zoom-range-container">
        <input
          #zoomRangeInputRef
          class="zoom-range-input"
          type="range"
          min="-50"
          max="100"
          (change)="onRangeChanged()"
          (input)="onRangeChanged()"
        />
      </div>
      <button class="zoom-button" (click)="zoomIn()" [intercomTarget]="'01-gojs-overview-zoomin'">
        <fa-icon [icon]="['fal', 'search-plus']"></fa-icon>
      </button>
      <span class="diagram-scale" style="width: 45px; height: 35px">{{ state.diagramScale }}</span>
    </div>
  </div>
</div>
